import { createFileRoute, notFound } from '@tanstack/react-router'
import { PageHeader } from '@/components/shell/page'
import { ALL_LINKS } from '@/components/shell/nav'
import { useTitle } from '@/lib/use-title'

/** Placeholder for modules not yet built: says plainly what the section will do. */
export const Route = createFileRoute('/_app/$section')({
  loader: ({ params }) => {
    const link = ALL_LINKS.find((l) => l.to === `/${params.section}`)
    if (!link) throw notFound()
    return { title: link.title, summary: link.summary, to: link.to }
  },
  component: SectionPlaceholder,
})

function SectionPlaceholder() {
  const { title, summary, to } = Route.useLoaderData()
  const link = ALL_LINKS.find((l) => l.to === to)!
  useTitle(title)
  return (
    <>
      <PageHeader title={title} />
      <section className="flex flex-col items-start gap-4 rounded-xl border border-dashed bg-card px-6 py-10 sm:px-10">
        <span className="flex size-12 items-center justify-center rounded-lg bg-accent text-accent-foreground">
          <link.icon className="size-6" aria-hidden />
        </span>
        <div>
          <h2 className="text-lg font-semibold">Not built yet</h2>
          <p className="mt-1 max-w-[60ch] text-[15px] text-muted-foreground">{summary}</p>
        </div>
      </section>
    </>
  )
}
